import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FooterSection = () => {
  const contactLinks = [
    {
      name: 'Website',
      icon: 'Globe',
      url: 'http://guofsyrians.org'
    },
    {
      name: 'Email',
      icon: 'Mail',
      url: 'mailto:guofsysrians@gmail.com'
    },
    {
      name: 'Phone',
      icon: 'Phone',
      url: 'tel:+90 507 530 88 10'
    }
  ];

  return (
    <footer id="footer" className="mt-auto bg-primary text-primary-foreground">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="flex flex-col items-center text-center space-y-6">
          {/* Logo */}
          <div className="mb-4">
            <Image
              src="/assets/logos/لوغو المؤتمر العــام الثاني عمودي اخضر واصفر.png"
              alt="المؤتمر العام الثاني للاتحاد العام لطلبة سوريا"
              className="h-24 md:h-32 lg:h-40 w-auto object-contain brightness-0 invert"
            />
          </div>

          {/* Location and Date */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-white">
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={20} className="text-white" />
              <span className="font-body text-sm md:text-base">Istanbul Gelişim Üniversitesi</span>
            </div>
            <div className="hidden md:block">|</div>
            <div className="flex items-center gap-2" dir="rtl">
              <Icon name="Calendar" size={20} className="text-white" />
              <span className="font-body text-sm md:text-base">31 يناير - 01 فبراير 2026</span>
            </div>
          </div>

          {/* Contact Links */}
          <div className="flex items-center justify-center gap-4 md:gap-6 pt-4">
            {contactLinks.map((contact, index) => (
              <React.Fragment key={contact.name}>
                <a
                  href={contact.url}
                  target={contact.name === 'Email' || contact.name === 'Phone' ? undefined : '_blank'}
                  rel={contact.name === 'Email' || contact.name === 'Phone' ? undefined : 'noopener noreferrer'}
                  className="flex items-center gap-2 text-white hover:opacity-80 transition-opacity"
                  aria-label={contact.name}
                >
                  <Icon name={contact.icon} size={20} className="text-white" />
                </a>
                {index < contactLinks.length - 1 && (
                  <span className="text-white/50 hidden md:inline">|</span>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Copyright */}
          <div className="pt-6 border-t border-white/20 w-full">
            <p className="font-body text-sm md:text-base text-white/90 mb-2" dir="rtl">
              © 2026 الاتحاد العام لطلبة سوريا. جميع الحقوق محفوظة.
            </p>
            <p className="font-body text-xs md:text-sm text-white/70" dir="rtl">
              تم تطوير هذا الموقع بواسطة{' '}
              <a
                href="https://www.qk-dev.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:underline transition-opacity"
              >
                QK-dev Software Services
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
